import { useState, useRef, useEffect, ChangeEvent } from "react";
import {
  Box,
  FormControl,
  FormHelperText,
  IconButton,
  InputLabel,
  ListSubheader,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CancelIcon from "@mui/icons-material/Cancel";
import axios from "axios";
import toast from "react-hot-toast";

const STYLES = {
  LIST_SUB_HEADER: { p: 0, mb: 1.5, position: "static" },
  USERS_CONTIANER: {
    maxHeight: "280px",
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    gap: 1,
  },
  USER: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    p: 0,
    borderBottom: "1px solid #e0e0e0",
  },
};

export default function SearchSelect({
  users = [],
  role_id = "",
  updateUsers,
}: any) {
  const [search, setSearch] = useState("");
  const [errorMessage, setErrorMessage] = useState<string | boolean>(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleSearch = (event: ChangeEvent<HTMLInputElement>) => setSearch(event.target.value);
  const handleRemoveUser = async (user_id: number | string) => {
    try {
      await axios.post("/roles/delete-user-from-role", {
        user_id,
        role_id,
      });

      updateUsers(user_id);
    } catch (error) {
      toast.error("Something went wrong");

      console.log(error);
    }
  };

  return (
    <>
      <ListSubheader sx={STYLES.LIST_SUB_HEADER}>
        <TextField
          InputProps={{ ref: inputRef }}
          onKeyDown={(e) => {
            if (e.key !== "Escape") e.stopPropagation();
          }}
          fullWidth
          id="search-input"
          label="Search User by Name"
          variant="standard"
          onChange={handleSearch}
          value={search}
        />
      </ListSubheader>
      <Box sx={STYLES.USERS_CONTIANER}>
        {users.length > 0 ? (
          users
            .filter((user: any) =>
              user.name.toLowerCase().includes(search.toLowerCase())
            )
            .map((item: any, index: number) => (
              <Box key={`${item.name} - ${index}`} sx={STYLES.USER}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <img
                    src={item.avatar}
                    alt={item.name}
                    width="40px"
                    style={{ borderRadius: "50%" }}
                  />
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    {item.name}
                    <Typography
                      variant="caption"
                      sx={{
                        color: item.status === "Active" ? "#14af2b" : "#af1414",
                      }}
                    >
                      {item.status}
                    </Typography>
                  </Box>
                </Box>
                <IconButton
                  color="error"
                  onClick={() => handleRemoveUser(item.id)}
                >
                  <CancelIcon />
                </IconButton>
              </Box>
            ))
        ) : (
          <MenuItem disabled>No results found</MenuItem>
        )}
      </Box>
      {Boolean(errorMessage) && <FormHelperText>{errorMessage}</FormHelperText>}
    </>
  );
}
